import { CalendarDays } from "lucide-react";
import { INK_HEX } from "./numbersModel";

const fmtDate = (d) => (/^\d{4}-\d{2}-\d{2}$/.test(d || "")
  ? new Date(`${d}T00:00:00`).toLocaleDateString("en-AU", { day: "2-digit", month: "short" }) : "");

// Groups are folders (Day_1, Day_2…) when the same image number repeats across folders, else dates.
export const dayLabel = (g, i) => {
  if (!g.day) return "All photos";
  const isDate = /^\d{4}-\d{2}-\d{2}$/.test(g.day);
  const name = isDate ? `Day ${i + 1}` : g.day.split("/").pop();
  const date = fmtDate(isDate ? g.day : g.date);
  return date ? `${name} · ${date}` : name;
};

export function InkDayBar({ inks, days, inkDays, autoDays, onChange }) {
  if (!inks.length || days.length < 2) return null;
  return (
    <div className="px-4 py-2 border-b border-amber-700/50 flex flex-wrap items-center gap-3 bg-amber-950/20" data-testid="ink-day-bar">
      <span className="text-[10px] uppercase tracking-widest font-bold text-amber-200 inline-flex items-center gap-1">
        <CalendarDays className="h-3.5 w-3.5" />Pick the day folder for each pen colour
      </span>
      {inks.map((ink) => (
        <label key={ink} className="inline-flex items-center gap-1.5 text-[11px] text-slate-300">
          <span className="h-2.5 w-2.5 rounded-full" style={{ background: INK_HEX[ink] || "#cbd5e1" }} />
          <span className="capitalize">{ink}</span>
          <select
            value={inkDays[ink] || ""}
            onChange={(e) => onChange(ink, e.target.value)}
            className={`h-7 px-1.5 rounded-sm bg-slate-950 border ${inkDays[ink] ? "border-slate-800" : "border-red-500"} text-[11px] text-slate-100 focus:outline-none focus:border-amber-400`}
            data-testid={`ink-day-select-${ink}`}
          >
            {!inkDays[ink] && <option value="">—</option>}
            {days.map((d, i) => (
              <option key={d.day} value={d.day}>
                {dayLabel(d, i)} ({d.count}){autoDays[ink] === d.day ? " · auto" : ""}
              </option>
            ))}
          </select>
        </label>
      ))}
      {inks.some((i) => !inkDays[i]) && (
        <span className="text-[10px] text-red-300" data-testid="ink-day-missing-warning">Every colour needs a day before matching</span>
      )}
      {new Set(inks.map((i) => inkDays[i]).filter(Boolean)).size < inks.filter((i) => inkDays[i]).length && (
        <span className="text-[10px] text-amber-300" data-testid="ink-day-duplicate-warning">Two colours are set to the same day — check this is intended</span>
      )}
    </div>
  );
}
